import cn from "classnames"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { useFilterContext } from "~/components/FilterWrapper/FilterWrapper"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

type Props = {
  isFullWidth?: boolean
  isLight?: boolean
}

export const ShowMore: React.FC<Props> = ({ isFullWidth = true, isLight }) => {
  const { t } = useTranslation()
  const { filterState, updateFilterState, totalPages, isLoading } = useFilterContext()
  const [nextPageIsLoading, setIsLoading] = useState(false)
  const isVisible = totalPages > filterState.page_number!

  useEffect(() => {
    if (!nextPageIsLoading) {
      return
    }

    setIsLoading(isLoading)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  if (!isVisible) {
    return null
  }

  const onClick = (): void => {
    updateFilterState({ page_number: filterState.page_number + 1 })
    setIsLoading(true)
  }

  return (
    <button
      className={cn(styles.Button, {
        [styles.FullWidth]: isFullWidth,
        [styles.IsLoading]: nextPageIsLoading,
        [styles.IsLight]: isLight,
      })}
      disabled={isLoading}
      onClick={onClick}
    >
      <Raw html={t("Pagination.ShowMore.Button")} />
    </button>
  )
}
